module.exports = __webpack_public_path__ + "static/media/career_content_1.80fcc7c5.png";